import React, { useMemo, useState } from 'react';
import {
    FollowingCollegesForPlayersDocument,
    FollowingCollegesForPlayersQuery,
    FollowingCollegesForPlayersQueryVariables,
    GetChildProfilesDocument,
    GetChildProfilesQuery,
    GetChildProfilesQueryVariables,
} from '../../../generated/spin-graphql';
import { ParentChildDropdown } from '../ParentChildDropdown';

import { gql } from 'urql';
import { useAuthenticatedQuery } from 'client/hooks';
import { useAppState } from 'client/providers/AppProvider';
import { PlayerFollowing } from './PlayerFollowing';
import { CONVERT_TO_MILES } from 'shared/shared.constants';

gql`
    query GetChildProfiles($id: String!) {
        espin_parent_profile(where: { user_id: { _eq: $id } }) {
            ...ChildData
        }
    }
`;

type Props = {};

export const ParentFollowing: React.FC<Props> = ({}) => {
    const { user } = useAppState();

    const [selectedPlayer, setSelectedPlayer] = useState(0);

    const { isReady: childProfileReady, data: childProfileData } = useAuthenticatedQuery<
        GetChildProfilesQuery,
        GetChildProfilesQueryVariables
    >({
        query: GetChildProfilesDocument,
        variables: useMemo(() => ({ id: user?.id }), [user]),
        pause: !user,
    });
    const { isReady, data } = useAuthenticatedQuery<
        FollowingCollegesForPlayersQuery,
        FollowingCollegesForPlayersQueryVariables
    >(
        {
            query: FollowingCollegesForPlayersDocument,
            variables: {
                farSearch: {
                    _not: {
                        address: {
                            location: {
                                _st_d_within: {
                                    distance: 100 * CONVERT_TO_MILES,
                                    from: {
                                        type: 'Point',
                                        coordinates: childProfileData?.espin_parent_profile?.[0]?.child_profiles[
                                            selectedPlayer
                                        ].address.location?.['coordinates'] ?? [0, 0],
                                    },
                                },
                            },
                        },
                    },
                },
                closeSearch: {
                    address: {
                        location: {
                            _st_d_within: {
                                distance: 100 * CONVERT_TO_MILES,
                                from: {
                                    type: 'Point',
                                    coordinates: childProfileData?.espin_parent_profile?.[0]?.child_profiles[
                                        selectedPlayer
                                    ].address.location?.['coordinates'] ?? [0, 0],
                                },
                            },
                        },
                    },
                },
            },
            pause: !childProfileReady,
        },
        ['espin_follow'],
    );
    const listOfFollows = useMemo(() => data?.all_follows.map((f) => f.college.id), [data?.all_follows]);
    if (!childProfileReady) {
        return <></>;
    }

    return (
        <>
            {childProfileData?.espin_parent_profile?.[0]?.child_profiles?.length > 1 && (
                <div className="parent-dropdown-container">
                    <ParentChildDropdown
                        playerInfo={childProfileData.espin_parent_profile}
                        value={childProfileData.espin_parent_profile[0].child_profiles[selectedPlayer]}
                        onChange={(value) => {
                            setSelectedPlayer(value);
                        }}
                    />
                </div>
            )}

            {isReady && (
                <PlayerFollowing
                    closeColleges={data.close_colleges}
                    farColleges={data.far_colleges}
                    listOfFollows={listOfFollows}
                    selectedPlayer={selectedPlayer}
                />
            )}
        </>
    );
};
